import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { FiArrowRight, FiEye, FiEyeOff, FiLock, FiMail } from "react-icons/fi";
import logo from "../../assets/logo/logo.png";
import { adminApi } from "../../admin/api";
import { setAdminAuth } from "../../admin/adminStorage";
import "./AdminLogin.css";

export default function AdminLogin() {
  const navigate = useNavigate();
  const location = useLocation();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const from = location.state?.from?.pathname || "/admin/dashboard";

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((current) => ({ ...current, [name]: value }));
    if (error) setError("");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    if (!form.email.trim() || !form.password) {
      setError("Please enter your email and password.");
      return;
    }

    setLoading(true);

    try {
      // const result = await adminApi.login(form.email.trim(), form.password);
      // setAdminAuth({
      //   token: result.token || result.accessToken || "",
      //   name: result.admin?.name || result.name || "Admin",
      //   email: result.admin?.email || result.email || form.email.trim(),
      //   role: result.admin?.role || result.role || "Administrator",
      // });

      const result = await adminApi.login(form.email.trim(), form.password);

      const token = result.token || result.accessToken;

      if (!token) {
        throw new Error("Authentication token was not received.");
      }

      // Verify the JWT with the backend before saving it.
      await adminApi.verifyToken(token);

      // Save only after successful verification.
      setAdminAuth({
        token,
        name: result.admin?.name || result.name || "Admin",
        email: result.admin?.email || result.email || form.email.trim(),
        role: result.admin?.role || result.role || "Administrator",
      });

      navigate(from, { replace: true });

      navigate(from, { replace: true });
    } catch (err) {
      setError(err.message || "Unable to sign in.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="admin-login-page">
      <div className="admin-login-decor admin-login-decor-one" />
      <div className="admin-login-decor admin-login-decor-two" />

      <section className="admin-login-card">
        <div className="admin-login-brand">
          <div className="admin-logo-wrap">
            <img src={logo} alt="Yadnya Handloom" />
          </div>
          <p className="admin-login-kicker">Yadnya Handloom</p>
          <h1>Admin Portal</h1>
          <p className="admin-login-subtitle">
            Manage your handloom collection with ease.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="admin-field">
            <label htmlFor="admin-email">Email Address</label>
            <div className="admin-input-wrap">
              <FiMail />
              <input
                id="admin-email"
                name="email"
                type="email"
                placeholder="Enter Username"
                value={form.email}
                onChange={handleChange}
                autoComplete="username"
              />
            </div>
          </div>

          <div className="admin-field">
            <label htmlFor="admin-password">Password</label>
            <div className="admin-input-wrap">
              <FiLock />
              <input
                id="admin-password"
                name="password"
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                value={form.password}
                onChange={handleChange}
                autoComplete="current-password"
              />
              <button
                type="button"
                className="password-toggle"
                onClick={() => setShowPassword((value) => !value)}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <FiEyeOff /> : <FiEye />}
              </button>
            </div>
          </div>

          {error && <div className="admin-login-error">{error}</div>}

          <button
            type="submit"
            className="admin-login-submit"
            disabled={loading}
          >
            <span>{loading ? "Signing in..." : "Sign In"}</span>
            {!loading && <FiArrowRight />}
          </button>
        </form>

        <div className="admin-login-footer">
          <span />
          <p>Secure Admin Access</p>
          <span />
        </div>
      </section>
    </main>
  );
}
